import api from "@/api/api"
import { query } from "../api/queries"
import router from "@/router/"

export default {
	async signIn({ commit, rootState }, payload) {
		const { tenantId, clientId } = rootState

		const res = await api({
			query: query.logInAuth,
			variables: {
				clientId,
				tenantId,
				...payload
			}
		})
		if (res?.data?.token_2?.accessToken === null) return Promise.reject(res)

		const token = res?.data?.token_2?.accessToken
		const refreshToken = res?.data?.token_2?.refreshToken
		commit("setTenantId", tenantId, { root: true })
		window.localStorage.setItem(process.env.VUE_APP_TOKEN_KEY, token)
		window.localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN_KEY, refreshToken)
		commit("setToken", token)
		return Promise.resolve(res)
	},

	setAccessToken({ commit }, payload) {
		commit("setToken", payload)
	},

	logoutWithLogin(_, { tenantId } = {}) {
		window.localStorage.removeItem(process.env.VUE_APP_TOKEN_KEY)
		window.localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN_KEY)
		router.push({ name: "ViewAuthLogin", query: { tenantId } })
	}
}
